<template>
  <Modal
    :visible="isModal"
    :pop_tit="popTit"
    popSizeClass="popup__container--l"
    @close="closeModal"
  >
    <template #pop_content>
      <div class="reason-modal-content">
        <table class="form-table type-block--mobile">
          <caption>
            수정 사유 목록
          </caption>
          <tbody>
            <tr>
              <th scope="row">
                수정 사유<span
                  class="svg_icon icon_must"
                  aria-hidden="true"
                ></span
                ><span class="sr-only">필수입력</span>
              </th>
              <td>
                <div style="padding-bottom: 5px">
                  <label for="reason-select" class="sr-only"></label
                  ><select v-model="reasonCode" id="reason-select">
                    <option :value="null" disabled>
                      수정 사유를 선택하세요
                    </option>
                    <option
                      v-for="item in items"
                      :key="item.cd"
                      :value="item.cd"
                    >
                      {{ item.cdNm }}
                    </option>
                  </select>
                </div>
                <textarea
                  placeholder="수정 사유 내용을 작성하여 주시기 바랍니다."
                  v-show="reasonCode === freeInputCode"
                  class="chat__textarea"
                  id="reason-textarea"
                  v-model="description"
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #pop_buttons>
      <button
        type="button"
        class="btn btn--m btn--blue"
        @click="applySelectionReason"
      >
        수정
      </button>
    </template>
  </Modal>
</template>
<script>
import Modal from "@/component/modal/Modal.vue";
import { inject, onMounted, ref } from "vue";
import { useStore } from "vuex";

export default {
  name: "ReasonModal",
  components: { Modal },
  props: {
    isModal: { type: Boolean, default: false },
    popTit: { type: String, default: "수정 사유" },
    apiUrl: { type: String, required: true },
    freeInputCode: { type: String, required: true },
  },
  emits: ["close", "set"],
  setup(props, { emit }) {
    const axios = inject("axios");
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const items = ref([]);
    const reasonCode = ref(null);
    const description = ref("");

    // methods 정의
    const getReasonCodeList = () => {
      showLoading();
      axios
        .post(props.apiUrl)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            items.value = res.data.resList;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
          items.value = [];
        })
        .finally(() => {
          hideLoading();
        });
    };

    const closeModal = () => {
      emit("close");
    };

    const applySelectionReason = () => {
      if (!reasonCode.value) {
        alert("수정 사유를 선택해주세요.");
        return;
      }
      if (reasonCode.value === props.freeInputCode && !description.value.trim()) {
        alert("수정 사유 내용을 입력해주세요.");
        return;
      }
      emit("set", {
        reasonCode: reasonCode.value,
        description: description.value,
      });
    };

    // life cycle 정의
    onMounted(() => {
      getReasonCodeList();
      reasonCode.value = props.freeInputCode;
      description.value = "";
    });

    // html에서 사용될 데이터 정의
    return {
      items,
      reasonCode,
      description,
      closeModal,
      applySelectionReason,
    };
  },
};
</script>
